export default __webpack_public_path__ + "static/why-ml-9-29a17de2c3789fbafbd4084d7407ca65.jpg";